package com.far.suller.util

object Constants {
    const val VERSION = "2.0.3"
    const val FACEBOOK_LINK = "https://www.facebook.com/florencze"
    const val GITHUB_LINK = "https://github.com/farsuller"
    const val GOOGLE_DEVELOPER_LINK =
        "https://play.google.com/store/apps/dev?id=8531625098803100156"
    const val LINKEDIN_LINK = "https://www.linkedin.com/in/florence-arnold-suller-954b12164/"

    const val ANIMELOOM = "https://play.google.com/store/apps/details?id=com.solodev.animeloom"
    const val CURRENZY = "https://play.google.com/store/apps/details?id=com.solodev.currenzy"
    const val SOLOFOLIO = "https://play.google.com/store/apps/details?id=com.portfolio.portfoliofs"
    const val SOLOSCAPE = "https://play.google.com/store/apps/details?id=com.soloscape.compose"
    const val SOLOEATS = "https://play.google.com/store/apps/details?id=com.solo.solodemo"
    const val SOLODAILY = "https://play.google.com/store/apps/details?id=com.solo.solodaily"
    const val MCDELIVERY_LINK = "https://play.google.com/store/apps/details?id=ph.mobext.mcdelivery"
    const val UNIONBANK = "https://play.google.com/store/apps/details?id=com.unionbankph.online"
    const val FLEET_DRIVE_BACKOFFICE = "https://fleet-management-backoffice-latest.onrender.com/"

    const val SECTION_WIDTH = 2560 // Increased from 1920 to support wider screens
    const val FONT_FAMILY = "Roboto"
    val AMBER_500 = com.varabyte.kobweb.compose.ui.graphics.Color.rgb(245, 158, 11)

    const val ANDROID_SERVICE =
        "Over 8 years of engineering excellence in native Android development using Kotlin and Jetpack Compose. Expert in multi-module architecture, high-performance UI, and complex system integrations like live vehicle tracking."
    const val IOS_SERVICE =
        "Experienced in cross-platform development with Flutter and managing iOS app lifecycles. Familiar with Swift, UIKit, and App Store distribution."
    const val WEB_SERVICE =
        "Hands-on expertise in modern web frameworks like Svelte and React. Proficient in Tailwind CSS and building enterprise-grade, responsive dashboards using Kobweb."
    const val CROSS_PLATFORM_SERVICE =
        "Dedicated to building high-quality cross-platform solutions using Flutter and Unity. Experienced in managing mobile assets and optimizing game performance for global releases."
    const val UI_UX_SERVICE =
        "Specialized in enterprise-grade UI/UX design using Figma and Adobe XD. Capable of translating complex designs into clean, maintainable code with a strong focus on brand identity."
    const val EDITING_SERVICE =
        "Experienced in professional video editing and visual effects using Adobe After Effects, bringing a decade of creative technical expertise to digital storytelling."

    const val ABOUT_ME =
        "Senior Android Developer with over 8 years of experience, specializing in native engineering with growing expertise in backend and core service development. I have delivered end-to-end mobile solutions using Kotlin, MVVM/CLEAN architecture, and modern frameworks, while also pioneering hybrid integrations using Vue and Svelte. I leverage AI-assisted development tools to improve productivity and code quality."
    val MAIN_INTRO =
        listOf(
            "Software developer focused on Kotlin, Android, backend systems, and scalable operational platforms built for real-world use.",
            "Professional: Software developer focused on Kotlin, Android, scalable systems, and modern application architecture.",
            "Modern Tech Style: Building reliable applications, connected systems, and scalable digital solutions for real-world operations.",
            "Minimal: Kotlin Developer • Android Developer • System Builder",
            "Startup / Founder Style: I create practical software systems that combine mobile apps, backend infrastructure, and operational technology.",
            "Portfolio Style: Developer specializing in Android, Compose Multiplatform, backend integrations, and offline-first systems.",
            "More Personal: Passionate about building technology that solves real operational problems through scalable and reliable software.",
            "Stronger / Premium Feel: Designing and developing scalable digital systems with focus on performance, reliability, and modern user experience.",
            "Clean One-Liner: Software developer focused on modern apps, scalable systems, and real-world technology solutions.",
            "Tech + Infrastructure Focus: Exploring the intersection of software, infrastructure, operations, and emerging technologies.",
        )

    val BIO_PARAGRAPHS = listOf(
        "I’m an Android and Kotlin developer with 8+ years of experience building native mobile applications and connected systems across startups and enterprise projects, including banking, logistics, fleet management, food ordering, and backoffice platforms. My expertise includes Compose Multiplatform, backend integrations, offline-first architecture, and API-driven applications designed for real-world reliability.",
        "I also integrate AI-assisted development workflows to speed up delivery, especially for repetitive implementation patterns, while still maintaining strong engineering standards. I don’t rely on “fire-and-forget” vibe coding — I focus on security, testing, maintainability, and scalable architecture, backed by experience across frontend, backend, infrastructure, and production systems.",
        "Beyond development, I also have experience in UI and product design, which I apply in my personal projects and applications to create clean and intuitive user experiences. I’m highly interested in technology infrastructure, transportation systems, aerospace, and emerging technologies, especially how large-scale systems and operations work together in real environments.",
    )

    const val NAME = "Florence Arnold R. Suller"
    const val ROLE = "Frontend Android | Full Stack Engineer"
    const val HIRE_ME = "Hire Me"
    const val INTRO = "Hello I'm"

    val ASCENDION =
        listOf(
            "▪ Role: Frontend Android (July 2025 – Present).",
            "▪ Utilized Android development technologies including Android Studio, Kotlin, XML, MVVM and MVP architectures, Repository Pattern, and dependency injection with Hilt.",
            "▪ Delivered hybrid solutions by integrating web components built with Vue and Svelte into native Android applications using WebView and related frameworks.",
            "▪ Contributed to backend and core service development tasks, supporting API design, business logic implementation, and system integrations.",
            "▪ Leveraged AI-assisted development tools to accelerate prototyping, code generation, refactoring, and debugging while ensuring code quality, security, and maintainability standards were met.",
            "▪ Participated in daily stand-ups, sprint planning, refinement, and reviews to discuss progress, blockers, and upcoming work. Worked on assigned Android, hybrid web, and backend-related tasks.",
            "▪ Produced clean, maintainable code with supporting technical documentation, and actively participated in Android guild meetings and cross-team discussions to align on technical standards.",
        )

    val BCS =
        listOf(
            "▪ Role: Android Developer (Nov 2024 – May 2025).",
            "▪ Utilized Android Studio, Kotlin, XML, MVVM, Flow, Repository Pattern, and Koin.",
            "▪ Managed version control through Git and Azure DevOps.",
            "▪ Collaborated closely with product owners and team members to ensure aligned delivery of assigned features.",
        )

    val FPT =
        listOf(
            "▪ The technologies utilized include Android Development, Android Studio, Kotlin, Java, Jetpack Compose, Bitbucket, Confluence, Linux.",
            "▪ Attend daily stand-up and planning to discuss project progress and roadblocks, sprint planning and refinements.",
            "▪ Develop assigned tasks, provide pull requests and testing, in every sprint cycle.",
            "▪ Review provided logs for investigation for crash issues and review UI Design for development.",
            "▪ Run flash on a virtual device for development and testing via Linux.",
            "▪ Utilized appropriate tools and platforms to maintain and distribute the documentation effectively within the team and to relevant stakeholders.",
        )

    val COLLABERA =
        listOf(
            "▪ The technologies utilized include Android SDK, Gradle, Kotlin, Java, XML, Api Integration, Retrofit, Modular Projects, CLEAN, MVVM, Version Control Git, Unit Testing, CI/CD, Firebase, Gitlab.",
            "▪ Attend daily stand-up and planning to discuss project progress and roadblocks, sprint planning and refinements.",
            "▪ Collaborated with a cross-functional team, including product owners, delivery leads, team leads, back-end developers, and UI/UX designers, ensuring seamless communication and alignment to achieve assigned feature delivery.",
            "▪ Developed new features based on provided API requirements. Submit pull requests for each task assigned during the Sprint cycle.",
            "▪ Utilized automated unit testing, CI/CD process and other tools and platforms to publish and  maintain then distribute the documentation.",
        )

    val YONDU =
        listOf(
            "▪ The technologies utilized include Android SDK, Gradle,  Kotlin, Java, XML, Retrofit, REST API,  MVVM, Version Control Git, Firebase, Google Cloud Platform, Google Maps Integration, Gitlab.",
            "▪ Attend daily stand-up, planning and refinement on Jira Kanban tickets to keep track of progress.",
            "▪ Collaborated with the other platform developers, UI/UX Designer, QA Team, Business Analyst, and Scrum Master to align development efforts seamlessly.",
            "▪ Maintained internal client multiple apps and conducted investigations of bug tickets, analyzing reported issues to identify root causes and potential solutions.",
            "▪ Developed and delivered new multiple features based on project tasks deliveries and API requirements.",
            "▪ Take lead and conduct knowledge transfer, task ticket features deliveries on other developers.",
            "▪ Delivered the requirements for Vulnerability Assessment and Penetration Testing from 3rd Party.",
            "▪ Utilized appropriate tools and platforms to maintain and distribute the documentation effectively within the team and to relevant stakeholders.",
        )

    val EMAPTA =
        listOf(
            "▪ The technologies utilized include Android SDK, Gradle, Kotlin, XML, 3rd Party Api Integrations, Analytics, Xcode, Objective-C, Bitbucket, MVVM, Version Control, Git.",
            "▪ Attend daily stand-up, planning and refinement on Jira Kanban tickets to keep track of progress.",
            "▪ Provided support for publishing credentials for the Play Store and App Store to other developers leading the development of a browser and video conference app.",
            "▪ Provided support to developers to provide other requirements tasks, and also by managing credentials for app uploads, and I oversee app publishing on both the Play Store and the App Store.",
            "▪ Utilized appropriate tools and platforms to maintain and distribute the documentation effectively within the team and to relevant stakeholders.\n",
        )

    val ZIGZAG =
        listOf(
            "▪ The technologies utilized include Android SDK, Gradle, Kotlin, Java, XML, Version Control, Git, MVVM, Api Integrations, Analytics, Xcode, Objective-C, Unity, C#, Flutter,  Dart, Bitbucket.",
            "▪ Collaborated with platform developers, UI/UX Designer, QA Team, Product Manager, and Scrum Master to align development efforts seamlessly.",
            "▪ Attend daily stand-up, planning and refinement on Jira Kanban tickets to track progress.",
            "▪ Tasked for data gathering, developed automated scripts to scrape data.",
            "▪ Tasked to do a MVP app using flutter.",
            "▪ Developed updates integrating third-party advertising, analytics, and fixes on existing android apps on the Play Store.",
            "▪ Developed new Ads Integration for casual games both Android and iOS.",
            "▪ Actively participated in company meetings and seminars to stay updated on organizational goals, projects, and industry trends.",
            "▪ Utilized appropriate tools and platforms to maintain and distribute the documentation effectively within the team and to relevant stakeholders.",
        )
}

object Res {
    object Image {
        const val background = "background.svg"
        const val logo = "logo.svg"
        const val mainImage = "main_image.png"
        const val aboutImage = "about_image.png"
        const val animeloom = "animeloom.png"
        const val currenzy = "currenzy.png"
        const val soloscape = "portfolio1.png"
        const val solofolio = "solofolio.jpg"
        const val soloeats = "soloeats.png"
        const val solodaily = "solodaily.png"
        const val portfolio3 = "portfolio3.png"
        const val portfolio5 = "portfolio5.png"
        const val avatar1 = "avatar1.png"
        const val avatar2 = "avatar2.png"
        const val avatar3 = "avatar3.png"
        const val avatar4 = "avatar4.png"
        const val avatar5 = "avatar5.png"
        const val avatar6 = "avatar6.png"
        const val fleetDrive1 = "portfolio_fleet_drive_backoffice.png"
        const val fleetDrive2 = "portfolio_fleet_drive_backoffice_2.png"

        const val WORK_1 = "work_zigzag_logo.jpg"
        const val WORK_2 = "work_emapta_logo.jpg"
        const val WORK_3 = "work_yondu_logo.jpg"
        const val WORK_4 = "work_collabera_digital_logo.jpg"
        const val WORK_5 = "work_fpt_software_logo.jpg"
        const val WORK_6 = "work_bcs_logo.jpg"
        const val WORK_7 = "work_ascendion_logo.jpg"
    }

    object Icon {
        const val android = "android_icon.svg"
        const val ios = "apple_icon.svg"
        const val web = "web_icon.svg"
        const val business = "business_icon.svg"
        const val design = "design_icon.svg"
        const val seo = "seo_icon.svg"
        const val video = "video_icon.svg"
        const val flutter = "cross_platform.svg"
        const val link_icon = "link_icon.svg"
        const val checkmark = "checkmark_icon.svg"
        const val shield = "shield_icon.svg"
        const val happy = "happy_icon.svg"
        const val team = "user_icon.svg"
        const val star = "star_icon.svg"
    }
}
